import { compose, withProps } from 'recompose'
import withType from 'components/common/hoc/withType'
import withHasMountedState from 'components/common/hoc/withHasMountedState'
import isAuthorized from 'helpers/check-authorization'
import BOTMyAppointmentsDetails from './BOTMyAppointmentsDetails'
import { arrayHasValues } from 'helpers/utils'

const withAppointmentDetailsProps = withProps(
  ({ appointments }) => ({
    isAuthorized: isAuthorized(),
    hasAppointments: arrayHasValues(appointments)
  })
)

export default compose(
  withType({ type: 'BOTMyAppointmentsDetails', placeholders: ['appointmentOptions', 'noAccountMessage']}),
  withAppointmentDetailsProps,
  withHasMountedState
)(BOTMyAppointmentsDetails)
